module.exports = __webpack_public_path__ + "assets/img/logo.188e2184.svg";